export default __webpack_public_path__ + "static/media/google-color.ea717441.svg";